import { graphql, useStaticQuery } from 'gatsby';

import { RecursiveNonNullable } from './types';

export const useCompanyQuery = () => {
  const {
    file: { childMdx: { frontmatter } },
  } = useStaticQuery<RecursiveNonNullable<Queries.CompanyQuery>>(graphql`
    query Company {
      file(
        sourceInstanceName: { eq: "content" }
        relativeDirectory: { eq: "" }
        name: { eq: "company" }
      ) {
        childMdx {
          frontmatter {
            company_address {
              street
              countryCode
              postCode
              city
              country
            }
            phone_number
            contact_email
          }
        }
      }
    }
  `);

  return frontmatter;
};
